export default class PatientStatistics {
    totalPatients: number;
    currentMonthPatients: number;
    upcomingAppointments: number;

    constructor(totalPatients: number, currentMonthPatients: number, upcomingAppointments: number) {
        this.totalPatients = totalPatients;
        this.currentMonthPatients = currentMonthPatients;
        this.upcomingAppointments = upcomingAppointments;
    }
}